import { authPut } from "@api";

import { Token } from "@pages/settings/types";

export const updateToken = (
  deploymentId: string,
  token: Token
): Promise<Token> => {
  const path = `/api/agent/deployments/${deploymentId}/tokens/${token.id}`;
  return authPut<Token, Token>(path, token);
};
